"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksQueryField = void 0;
var QuickbooksQueryField;
(function (QuickbooksQueryField) {
    QuickbooksQueryField["CONNECTED_STATUS"] = "connected_accounting";
})(QuickbooksQueryField || (exports.QuickbooksQueryField = QuickbooksQueryField = {}));
